import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TicketService } from 'src/app/shared/services/ticket.service';
import { HelpersService } from '@evento-ng/libs';

@Component({
  selector: 'app-cart-item',
  templateUrl: './cart-item.component.html',
  styleUrls: ['./cart-item.component.scss'],
})
export class CartItemComponent {
  @Input() item;
  @Input() review = false;
  isSport = false;
  selectedSeats: any[] = [];
  choosenTime = null;
  dateTimes;
  constructor(
    public helpers: HelpersService,
    private ticketService: TicketService,
    public translate: TranslateService,
    public router: Router
  ) {
    if (this.router.url.includes('sport')) {
      this.isSport = true;
    }
  }

  ngOnInit() {
    this.dateTimes = this.item?.ticketSchedule?.timeSchedules?.map((x) => {
      return {
        time: x?.time?.startAt,
        id: x?.time?.id,
      };
    });
    this.getSelectedSeats();
  }

  deleteItem(): void {
    this.ticketService.deleteItem(this.item);
  }

  selectTime(time) {
    this.choosenTime = time;
    const item = this.dateTimes.find((x) => x.id === time);
    this.ticketService.updateBookTicketItems({
      ...this.item,
      time: item,
    });
  }
  getSelectedSeats() {
    this.selectedSeats =
      this.ticketService.bookTicket.getValue()?.items?.[0]?.selectedSeats;
    return this.selectedSeats?.map((seat) => this.helpers.parseSeatCode(seat));
  }
}
